import React from "react";
import PropTypes from "prop-types";
import { BsChevronDown } from "react-icons/bs";
import Control from "../Control";
import * as S from "./SelectControl.Style";
import { applyKey } from "../../../../utils";

const SelectField = (props) => {
  return (
    <S.FieldContent>
      <S.SelectField {...props} />
      <S.SelectIcon as={BsChevronDown} />
    </S.FieldContent>
  );
};

const SelectControl = (props) => {
  const { placeholder, options, children } = props;

  return (
    <Control {...props} as={SelectField}>
      {placeholder ? <option value="">{placeholder}</option> : null}
      {applyKey(options, ({ value, label }) => (
        <option value={value}>{label}</option>
      ))}
      {children}
    </Control>
  );
};

SelectControl.defaultProps = {
  ...Control.defaultProps,
  options: [],
};

SelectControl.propTypes = {
  ...Control.propTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ),
};

export default SelectControl;
